import { MoovDefinitionDTO } from "../DTO/moovDefinitionDTO";
import { BasicRequest } from "./basicRequest";

export class CreateMoovDefinitionRequest extends BasicRequest{
   
    public moovDefinition! : MoovDefinitionDTO;
    
    constructor(){
        super();
    }
}